import ApisClient, { ApisClientNoLoader } from '../utils/client/ApisClient';

export const getAllConsumption = (productsPsId: any, page?: string) => {
    let params = '?';
    for (let i = 0; i < productsPsId.length; i++) {
        params += `productPsIds=${productsPsId[i]}`;
        if (i !== productsPsId.length - 1) params += '&';
    }
    if (page === 'sharedData') {
        return ApisClientNoLoader.get('/consumptions' + params);
    } else {
        return ApisClient.get('/consumptions' + params);
    }
};

export const getAllConsDetail = (params: any) => {
    return ApisClientNoLoader.get('/consumptions/detail', {
        params: params,
    });
};
